import { Paths } from '../../constants/paths';
export const buildCategoryUrl = acCard => {
  var _acCard$productTypes;
  const category = acCard.category;
  const params = new URLSearchParams();
  if ((_acCard$productTypes = acCard.productTypes) !== null && _acCard$productTypes !== void 0 && _acCard$productTypes.includes('WORKFLOW_TEMPLATE')) {
    params.set('eco_OBJECTIVE', String(category.categories[0]));
    return `${Paths.SEARCH_RESULTS_WORKFLOW_TEMPLATES}?${params}`;
  }
  params.set('eco_PRODUCT_TYPE', 'APP');
  params.set('eco_CATEGORY', String(category.categories[0]));
  return `${Paths.SEARCH_RESULTS}?${params}`;
};
export const buildCollectionUrl = acCard => {
  var _acCard$collection;
  return Paths.FEATURED_COLLECTION.replace(':collectionSlug', ((_acCard$collection = acCard.collection) === null || _acCard$collection === void 0 ? void 0 : _acCard$collection.slug) || '');
};
export const buildListingUrl = slug => {
  return Paths.LISTING_DETAILS.replace(':listingSlug', slug);
};
export const buildSolutionsPartnerUrl = slug => {
  return Paths.SOLUTIONS_PARTNERS_CATEGORY.replace(':categorySlug', slug);
};
const getSuggestedSearchTab = pathname => {
  switch (pathname) {
    case Paths.APPS:
      return 'APP';
    case Paths.AGENTS:
      return 'AGENT';
    case Paths.SOLUTIONS_PARTNERS:
    case Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS:
      return 'SOLUTIONS_PARTNER_PROFILE';
    default:
      return undefined;
  }
};

/** Used when `Enter` is pressed from the search bar,
 * without clicking an autocomplete item. */
export const buildQuickSearchUrl = (search, pathname) => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_search', search);
  if (pathname === Paths.SEARCH_RESULTS_WORKFLOW_TEMPLATES) {
    return `${Paths.SEARCH_RESULTS_WORKFLOW_TEMPLATES}?${searchParams}`;
  }
  const suggestedSearchTab = getSuggestedSearchTab(pathname);
  if (suggestedSearchTab) searchParams.set('eco_PRODUCT_TYPE', suggestedSearchTab);
  return `${Paths.SEARCH_RESULTS}?${searchParams}`;
};
export const buildSearchUrl = (acCard, pathname) => {
  const searchParams = new URLSearchParams();
  searchParams.set('eco_search', acCard.term);
  if (acCard.query) searchParams.set('eco_queryType', String(acCard.query.queryType));
  if (pathname === Paths.SEARCH_RESULTS_WORKFLOW_TEMPLATES) {
    return `${Paths.SEARCH_RESULTS_WORKFLOW_TEMPLATES}?${searchParams}`;
  }
  const suggestedSearchTab = getSuggestedSearchTab(pathname);
  if (suggestedSearchTab) searchParams.set('eco_PRODUCT_TYPE', suggestedSearchTab);
  return `${Paths.SEARCH_RESULTS}?${searchParams}`;
};
export const buildCatalogServiceUrl = acCard => {
  var _acCard$catalogServic;
  const searchParams = new URLSearchParams();
  const catalogServiceId = (_acCard$catalogServic = acCard.catalogService) === null || _acCard$catalogServic === void 0 ? void 0 : _acCard$catalogServic.catalogServiceId;
  if (catalogServiceId !== undefined) searchParams.set('eco_PROFILE_CATALOG_SERVICES', String(catalogServiceId));
  return `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?${searchParams}`;
};